import {
  ReceivableDocumentType,
  RECEIVABLE_DOCUMENT_TYPE_LABELS,
} from "../../../utils/types";

export const ACCEPTED_DOCUMENT_TYPES = ".pdf,.png,.jpg,.jpeg,.heic,.doc,.docx";

export const DOCUMENT_TYPE_OPTIONS = Object.values(ReceivableDocumentType);

export const getDocumentTypeLabel = (value: ReceivableDocumentType | string) =>
  RECEIVABLE_DOCUMENT_TYPE_LABELS[value as ReceivableDocumentType] ?? value;

